import {
  ApiMutationConfig,
  ApiQueryConfig,
  ConnectorBuilderServiceRunnerType,
  ConnectorBuilderServiceType,
} from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';
import { urlPart } from 'data';
import {
  IntegrationService,
  IntegrationV1,
  UpsertIntegrationQueryBody,
} from 'features/integration/types';

const integrationsUrl = `${URLS.app}/api/integrations`;

type IntegrationLegacyPathParams = { $integrationId: urlPart };

type GetIntegrationLegacyConfig = ApiQueryConfig<
  IntegrationV1,
  IntegrationLegacyPathParams
>;

export const getIntegrationLegacy =
  createApiEndpoint<GetIntegrationLegacyConfig>({
    url: `${integrationsUrl}/$integrationId/details`,
    method: 'GET',
  });

type IntegrationPathParams = {
  $integrationId: urlPart;
};

type AddBasicIntegrationServicePostBody = {
  Id: number;
  SystemName: string;
  ServiceName: string;
  ServiceType: ConnectorBuilderServiceType;
  IsConnectorAppService: boolean;
  RunnerType: ConnectorBuilderServiceRunnerType;
};

type AddIntegrationServiceConfig = ApiMutationConfig<
  AddBasicIntegrationServicePostBody,
  IntegrationPathParams
>;

export const addIntegrationService =
  createApiEndpoint<AddIntegrationServiceConfig>({
    url: `${integrationsUrl}/$integrationId/AddSequence`,
    method: 'POST',
  });

type UpdateIntegrationServicesConfig = ApiMutationConfig<
  IntegrationService[],
  IntegrationPathParams,
  IntegrationService[]
>;

export const updateIntegrationServices =
  createApiEndpoint<UpdateIntegrationServicesConfig>({
    url: `${integrationsUrl}/$integrationId/IntegrationSequence`,
    method: 'POST',
  });

type RemoveIntegrationServiceConfig = ApiMutationConfig<
  IntegrationService,
  IntegrationPathParams
>;

export const removeIntegrationService =
  createApiEndpoint<RemoveIntegrationServiceConfig>({
    url: `${integrationsUrl}/$integrationId/RemoveSequence`,
    method: 'POST',
    invalidateNthAncestor: 1,
  });

type SaveIntegrationDefaultConfigConfig = ApiMutationConfig<
  { Schema: Record<string, unknown> },
  IntegrationPathParams
>;

export const saveIntegrationDefaultConfig =
  createApiEndpoint<SaveIntegrationDefaultConfigConfig>({
    url: `${integrationsUrl}/DefaultServiceConfiguration/$integrationId`,
    method: 'PUT',
  });

type UpsertIntegrationQueryConfig =
  ApiMutationConfig<UpsertIntegrationQueryBody>;

export const upsertIntegrationQuery =
  createApiEndpoint<UpsertIntegrationQueryConfig>({
    url: `${integrationsUrl}/AddQuery`,
    method: 'POST',
  });

type RemoveQueryPathParams = IntegrationPathParams & { $queryId: urlPart };

type RemoveIntegrationQueryConfig = ApiMutationConfig<
  unknown,
  RemoveQueryPathParams
>;

export const removeIntegrationQuery =
  createApiEndpoint<RemoveIntegrationQueryConfig>({
    url: `${integrationsUrl}/$integrationId/DeleteIntegrationQuery/$queryId`,
    method: 'POST',
  });
